import { render, staticRenderFns } from "./IconBagSolid.vue?vue&type=template&id=f1797764&scoped=true&functional=true"
import script from "./IconBagSolid.vue?vue&type=script&lang=js"
export * from "./IconBagSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "f1797764",
  null
  
)

export default component.exports